import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RtAnalyticsModule } from '@recruitee/analytics';

import { AvatarModule } from '../avatar/avatar.module';
import { ButtonNewModule } from '../button-new/button-new.module';
import { ButtonModule } from '../button/button.module';
import { GroupModule } from '../group/group.module';
import { IconModule } from '../icon/icon.module';
import { TooltipModule } from '../tooltip/tooltip.module';
import { AdminsAvatarsComponent } from './admins-avatars.component';

@NgModule({
  imports: [
    AvatarModule,
    CommonModule,
    ButtonModule,
    ButtonNewModule,
    GroupModule,
    IconModule,
    RtAnalyticsModule,
    TooltipModule,
  ],
  declarations: [AdminsAvatarsComponent],
  exports: [AdminsAvatarsComponent],
})
export class AdminsAvatarsModule {}

export { AdminsAvatarsComponent } from './admins-avatars.component';
